import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const scrollPositions = new Map<string, number>();

export default function ScrollRestoration() {
  const { pathname, key: locationKey } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') {
      const savedY = scrollPositions.get(locationKey);
      if (savedY !== undefined && savedY > 0) {
        window.scrollTo({ top: savedY, behavior: 'auto' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return () => {
      scrollPositions.set(locationKey, window.scrollY);
    };
  }, [pathname, locationKey, navigationType]);

  return null;
}